import { Navigate, Route, Routes, useLocation } from "react-router-dom";
import { Layout } from "./components/Layout";
import { HomePage } from "./features/catalog/HomePage";
import { CatalogPage } from "./features/catalog/CatalogPage";
import { BookDetailPage } from "./features/catalog/BookDetailPage";
import { AuthorsPage } from "./features/catalog/AuthorsPage";
import { CategoriesPage } from "./features/catalog/CategoriesPage";
import { CollectionsPage } from "./features/catalog/CollectionsPage";
import { CartPage } from "./features/cart/CartPage";
import { CheckoutPage } from "./features/checkout/CheckoutPage";
import { LoginPage } from "./features/account/LoginPage";
import { MagicLinkPage } from "./features/account/MagicLinkPage";
import { MyLibraryPage } from "./features/library/MyLibraryPage";
import { RedeemPage } from "./features/catalog/RedeemPage";
import { TenantLandingPage } from "./features/tenant/TenantLandingPage";
import { TenantAdminPage } from "./features/tenant/TenantAdminPage";
import { AdminDashboardPage } from "./features/admin/AdminDashboardPage";
import { AdminCatalogPage } from "./features/admin/AdminCatalogPage";
import { AdminCollectionsPage } from "./features/admin/AdminCollectionsPage";
import { AdminCategoriesPage } from "./features/admin/AdminCategoriesPage";
import { AdminOrdersPage } from "./features/admin/AdminOrdersPage";
import { AdminCouponsPage } from "./features/admin/AdminCouponsPage";
import { AdminTenantsPage } from "./features/admin/AdminTenantsPage";
import { AdminAuditPage } from "./features/admin/AdminAuditPage";
import { AdminLicensesPage } from "./features/admin/AdminLicensesPage";
import { AdminCollaboratorsPage } from "./features/admin/AdminCollaboratorsPage";
import { AdminReportsPage } from "./features/admin/AdminReportsPage";
import { AdminSettingsPage } from "./features/admin/AdminSettingsPage";
import { AdminUsersPage } from "./features/admin/AdminUsersPage";
import { AdminEmailsPage } from "./features/admin/AdminEmailsPage";
import { PrivacyPage } from "./features/legal/PrivacyPage";
import { CookiesPage } from "./features/legal/CookiesPage";
import { TermsPage } from "./features/legal/TermsPage";
import { IndividualLicensePage } from "./features/legal/IndividualLicensePage";
import { CorporateLicensePage } from "./features/legal/CorporateLicensePage";
import { RefundPage } from "./features/legal/RefundPage";
import { ContactPage } from "./features/legal/ContactPage";
import { NotFoundPage } from "./features/NotFoundPage";

function LoginRedirect({ profile }: { profile: "reader" | "corporate" | "admin" }) {
  const { search } = useLocation();
  const params = new URLSearchParams(search);
  params.set("perfil", profile);
  return <Navigate to={`/login?${params.toString()}`} replace />;
}

export default function App() {
  return (
    <Layout>
      <Routes>
        <Route path="/" element={<HomePage />} />
        <Route path="/catalogo" element={<CatalogPage />} />
        <Route path="/livro/:slug" element={<BookDetailPage />} />
        <Route path="/autores" element={<AuthorsPage />} />
        <Route path="/categorias" element={<CategoriesPage />} />
        <Route path="/colecoes" element={<CollectionsPage />} />
        <Route path="/carrinho" element={<CartPage />} />
        <Route path="/checkout/:orderId" element={<CheckoutPage />} />
        <Route path="/minha-biblioteca" element={<MyLibraryPage />} />
        <Route path="/resgatar" element={<RedeemPage />} />
        <Route path="/conta" element={<LoginRedirect profile="reader" />} />
        <Route path="/login" element={<LoginPage />} />
        <Route path="/conta/magic-link" element={<MagicLinkPage />} />

        <Route path="/t/:tenantSlug" element={<TenantLandingPage />} />
        <Route path="/t-admin/login" element={<LoginRedirect profile="corporate" />} />
        <Route path="/t-admin/painel" element={<TenantAdminPage />} />

        <Route path="/admin/login" element={<LoginRedirect profile="admin" />} />
        <Route path="/admin" element={<AdminDashboardPage />}>
          <Route path="catalogo" element={<AdminCatalogPage />} />
          <Route path="colecoes" element={<AdminCollectionsPage />} />
          <Route path="categorias" element={<AdminCategoriesPage />} />
          <Route path="pedidos" element={<AdminOrdersPage />} />
          <Route path="cupons" element={<AdminCouponsPage />} />
          <Route path="tenants" element={<AdminTenantsPage />} />
          <Route path="licencas" element={<AdminLicensesPage />} />
          <Route path="colaboradores" element={<AdminCollaboratorsPage />} />
          <Route path="relatorios" element={<AdminReportsPage />} />
          <Route path="auditoria" element={<AdminAuditPage />} />
          <Route path="administradores" element={<AdminUsersPage />} />
          <Route path="emails" element={<AdminEmailsPage />} />
          <Route path="configuracao" element={<AdminSettingsPage />} />
        </Route>

        <Route path="/legal/privacidade" element={<PrivacyPage />} />
        <Route path="/legal/cookies" element={<CookiesPage />} />
        <Route path="/legal/termos" element={<TermsPage />} />
        <Route path="/legal/licenca-individual" element={<IndividualLicensePage />} />
        <Route path="/legal/licenca-corporativa" element={<CorporateLicensePage />} />
        <Route path="/legal/reembolso" element={<RefundPage />} />
        <Route path="/legal/contato" element={<ContactPage />} />

        <Route path="*" element={<NotFoundPage />} />
      </Routes>
    </Layout>
  );
}
